// export const backEndURL = "https://54.164.109.11:3001";
// export const imageURL = "https://54.164.109.11:3001";

// export const imageURL = "http://localhost:3001";
// export const backEndURL = "http://localhost:3001";

export const backEndURL = "https://rtechsl.lk";
export const imageURL = "https://rtechsl.lk";

